import { CardBrands } from 'mmfintech-backend-api'
import DinersIcon from '../images/cardBrands/diners_club.svg?react'
import DiscoverIcon from '../images/cardBrands/discover.svg?react'
import JCBIcon from '../images/cardBrands/jcb.svg?react'
import MasterCardIcon from '../images/cardBrands/mastercard.svg?react'
import UnionPayIcon from '../images/cardBrands/unionpay.svg?react'
import VisaLogo from '../images/cardBrands/visa.svg?react'

export const FindCardBrandLogo = ({ cardBrand }: { cardBrand: string }) => {
  switch (cardBrand) {
    case CardBrands.AMERICAN_EXPRESS:

    case CardBrands.DINERS_CLUB:
      return <DinersIcon />
    case CardBrands.DISCOVER:
      return <DiscoverIcon />

    case CardBrands.JCB:
      return <JCBIcon />

    case CardBrands.MASTERCARD:
      return <MasterCardIcon />

    case CardBrands.UNIONPAY:
      return <UnionPayIcon />

    case CardBrands.VISA:
      return <VisaLogo />

    default:
      return <DinersIcon />
  }
}
